import { canUseDOM } from 'exenv';
import get from 'lodash/get';
import extend from 'lodash/extend';
import authUtil from '../../utils/auth_util';
import cachingService from '../../services/caching_service';
import request from '../../utils/request_util';
import Base from '../base_model';
import log from '../../services/logger_service';

export default class CategoryFeatured extends Base {
  static fetch({ category, tag }, store, isTag) {
    const state = store.getState();
    const cacheEnabled = get(state, 'config.cacheEnabled');
    const tagStr = isTag ? `?tag=${tag}` : '';
    const cacheNamespace = get(state, 'config.cacheNamespace');
    const cacheExpire = get(state, 'config.cacheExpire');
    const site = get(state, 'config.site');
    const host = get(state, 'config.apiEndpoint') || 'fc-api.fastcompany.com';
    const protocol = get(state, 'config.protocol') || 'https://';
    const options = {};
    // api has auth in beta
    if (get(state, 'config.authEnabled')) {
      extend(options, authUtil(state));
    }

    const cacheKeyUrl = `${protocol}${host}/api/v2/category-featured-feed/${site}/${category}${tagStr}`;
    const cacheKey = `${cacheNamespace}:${cacheKeyUrl}`;
    if (!cacheEnabled) {
      return request.getAsync(cacheKeyUrl, options);
    }

    if (!canUseDOM) {
      log.info(`Requesting: ${cacheKeyUrl} from model.`);
    }
    return cachingService.getAsync(cacheKey).then(function fromCache(cacheRes) {
      // TODO: refactor so we only need to do this on server
      if (cacheRes) {
        return Promise.resolve(JSON.parse(cacheRes));
      }

      return request
        .getAsync(cacheKeyUrl, options)
        .then(function fetchSuccess(resp) {
          cachingService.setex(cacheKey, cacheExpire, JSON.stringify(resp));
          return resp;
        });
    });
  }
}
